import { AreaChart } from './lib/components/area/area-chart';
import { BarChart } from './lib/components/bar/bar-chart';
import { BoxPlot } from './lib/components/box/box-plot';
import { DivergingBarChart } from './lib/components/diverging-bar/diverging-bar-chart';
import { DivergingBarWithArrows } from './lib/components/diverging-bar/diverging-bar-with-arrows';
import { GaugeChart } from './lib/components/gauge/gauge-chart';
import { GroupedBarChart } from './lib/components/grouped-bar/grouped-bar-chart';
import { LineChart } from './lib/components/line/line-chart';
import { PieChart } from './lib/components/pie/pie-chart';
import { SankeyChart } from './lib/components/sankey/sankey-chart';
import { SingleMetricChart } from './lib/components/single-metric/single-metric-chart';
import { StackedBarChartHorizontal } from './lib/components/stacked-bar/stacked-bar-chart-horizontal';
import { TableChart } from './lib/components/table/table-chart';
import { TreeMap } from './lib/components/treemap/treemap';
import { VolumeChart } from './lib/components/volume/volume-chart';

/**
 * Single source of truth mapping a stable chart-type string to its replots
 * component. Used by:
 *   1. the share-capture HOC in `index.ts` to auto-register each chart's
 *      component name + props when rendered under a `ShareCaptureScope`, and
 *   2. the shared-report viewer to look up the component to live-render from
 *      the captured snapshot.
 *
 * Adding a new replots chart = add one import + one line here. No per-chart
 * registration hooks anywhere else.
 */
export const CHART_REGISTRY = {
  AreaChart,
  BarChart,
  BoxPlot,
  DivergingBarChart,
  DivergingBarWithArrows,
  GaugeChart,
  GroupedBarChart,
  LineChart,
  PieChart,
  SankeyChart,
  SingleMetric: SingleMetricChart,
  StackedBarChartHorizontal,
  TableChart,
  TreeMap,
  VolumeChart,
} as const;

export type ChartName = keyof typeof CHART_REGISTRY;
